<template>
    <loading :visible="isLoggingIn"></loading>
</template>

<script>
    import Loading from "../components/Loading";
    import { mapGetters } from "vuex";

    export default {
        name: "Login",
        components: { Loading },
        computed: {
            ...mapGetters('security', ['isLoggingIn'])
        }
    }
</script>

<style scoped>

</style>
